import'string.prototype.startswith';
import React from 'react';
import '../style/newSolicitorForm.css';
import ModalWrapper from '../helpers/modalWrapper';
import GroupButtons from '../helpers/groupButtons';
import TobaRevision from "./Tobas/tobaRevision";
import AttachmentsList from "./General/attachmentsList";
import CustomEditor from "./General/CustomEditor";
import { FormGroup, Button, Loader, Alert, Heading, HorizontalRule, List, DragAndDrop, FormInline } from 'arag-ui-lib';
import { FORM_GROUP_VARIANTS } from '../helpers/formGroupVariants';
import CONTENT_STRINGS from '../helpers/contentStrings';
import {
    DATE_FORMAT,
    SIZE_MD,
    SIZE_LG,
    PRIMARY,
    QUATERNARY,
    SUBMIT,
    DOTS,
    MEDIUM,
    RIGHT,
    ERROR,
    SUCCESS,
    HEADING_2,
    HEADING_3,
    HEADING_4,
    DOTTED,
    TERTIARY,
    MOMENT_DATE_TIME_FORMAT,
    BUTTON,
} from '../helpers/constants';
import { DROPZONE_ACCEPTED_FILES_ARRAY } from "../helpers/variables";
import moment from 'moment';

const NewTobaForm = (props) => {
    const {
        toba,
        goBack,
        handleSubmit,
        _handleUpdate,
        _onDrop,
        _getFileFromBase64,
        populateTobaFormFromRevision,
        closeTobaRevisionModal,
        closeUpdateTobaConfirmModal,
        closeCreateRevisionConfirmModal,
        formTitle,
        updateModalMessage,
        createRevisionMessage,
        futureRevisionsWarning,
        solicitorGroupsLabel,
        solicitorGroupsPlaceholder,
        selectedGroupsTitle,
        revisionsTitle,
        revisionModalTitle,
        validFromDate,
        minDate,
        showNameAndGroups,
        saveButtonLabel,
        cancelHandler,
        hasSelectedGroups,
        hasExistingToba,
        hasFetchedAttachments,
        futureTobaRevisionsExist,
        selectManyOptions,
        selectManyValue,
        handleUpdateConfirm,
        handleRevisionConfirm,
        handleFieldChange,
        handleValidFromChange,
        handleTobaBodyChange,
        handleSelectManyChange,
        selectedGroupListItems,
        attachments,
        onAttachmentRemove,
        fetchedAttachments,
        onFetchedAttachmentRemove,
        handleDownloadFile,
        _getFutureTobaRevisions,
        handleRevisionClick,
        tobaIsLive,
    } = props;

    if (toba.fetchingToba) {
        return <Loader variant={DOTS} dotSize={MEDIUM} />;
    }
    const futureRevisionListItems = _getFutureTobaRevisions().map(i => {
        const label = i.name + ' | ' + CONTENT_STRINGS.VALID_FROM;
        const value = moment(i.validFrom).format(MOMENT_DATE_TIME_FORMAT) + (moment(i.validUntil).isValid() 
            ? CONTENT_STRINGS.UNTIL + moment(i.validUntil).format(MOMENT_DATE_TIME_FORMAT) 
            : '');
        return {
            content: (
                <FormInline
                    labelSize={"col-sm-2"}
                    inputSize={"col-sm-9"}
                    variant={FORM_GROUP_VARIANTS.PLAIN}
                    label={label}
                    inputProps={{
                        id: `revisionValidFromUntil-${i.id}`,
                        name: `revisionValidFromUntil-${i.id}`,
                        label: value,
                    }}
                />
            ),
        };
    });

    
    const previousRevisionListItems = toba?.previousTobas?.length > 0
        ? 
            toba.previousTobas.map((tobaItem, index) => {
                const label = (
                    <>
                        {CONTENT_STRINGS.VALID} <strong>{CONTENT_STRINGS.FROM}</strong> {moment(tobaItem.validFrom).format(MOMENT_DATE_TIME_FORMAT)}
                        {
                            moment(tobaItem.validUntil).isValid() 
                            ? <> <strong>{CONTENT_STRINGS.UNTIL}</strong> {moment(tobaItem.validUntil).format(MOMENT_DATE_TIME_FORMAT)}</>
                            : null
                        }
                    </>
                );
                const editingNow = toba.tobaFormData.id === tobaItem.id ?
                    <span className="toba-revision-state">{CONTENT_STRINGS.EDITING_NOW}</span>
                    : null
                const liveVersion = tobaIsLive(tobaItem) ?
                    <span className="toba-revision-state">{CONTENT_STRINGS.LIVE_VERSION}</span>
                    : null
                    
                return {
                    linkItemTestId: `toba-revisions-${index}`,
                    content: (
                        <span
                            id={`revisionValidFromUntil-${tobaItem.id}`}
                            style={{ cursor: 'pointer' }}
                            onClick={handleRevisionClick(tobaItem.id)}
                        >
                            {label} {editingNow} {liveVersion}
                        </span>
                    ),
                }
            })
        : 
            [];

    return (
        <div className={"row"}>
            <div className={"col-sm-12"}>
                <ModalWrapper
                    isOpen={toba.confirmTobaUpdateModalOpen}
                    onClose={closeUpdateTobaConfirmModal}
                    title={CONTENT_STRINGS.CONFIRMATION}
                    size={SIZE_MD}
                >
                    <Heading
                        variant={HEADING_3}
                        title={updateModalMessage}
                    />
                    <Heading
                        variant={HEADING_3}
                        title={CONTENT_STRINGS.ARE_YOU_SURE}
                    />
                    <GroupButtons
                        primaryLabel={CONTENT_STRINGS.YES}
                        onPrimaryClick={handleUpdateConfirm}
                        primaryTestId={''}
                        secondaryLabel={CONTENT_STRINGS.NO}
                        onSecondaryClick={closeUpdateTobaConfirmModal}
                        secondaryTestId={''}
                    />
                </ModalWrapper>
                <ModalWrapper
                    isOpen={toba.confirmRevisionCreateModalOpen}
                    onClose={closeCreateRevisionConfirmModal}
                    title={CONTENT_STRINGS.CONFIRMATION}
                    size={SIZE_MD}
                >
                    <Heading
                        variant={HEADING_3}
                        title={createRevisionMessage}
                    />
                    {
                        futureTobaRevisionsExist ? (
                            <div>
                                <Heading
                                    variant={HEADING_3}
                                    title={futureRevisionsWarning}
                                />
                                <List
                                    items={futureRevisionListItems}
                                />
                            </div>
                        ) : null
                    }
                    <Heading
                        variant={HEADING_3}
                        title={CONTENT_STRINGS.ARE_YOU_SURE}
                    />
                    <GroupButtons
                        primaryLabel={CONTENT_STRINGS.YES}
                        onPrimaryClick={handleRevisionConfirm}
                        secondaryLabel={CONTENT_STRINGS.NO}
                        onSecondaryClick={closeCreateRevisionConfirmModal}
                    />
                </ModalWrapper>
                <Heading
                    variant={HEADING_2}
                    title={formTitle}
                />
                <form className={"form-horizontal solicitor-form-wrapper"} onSubmit={handleSubmit}>
                    {
                        showNameAndGroups ? (
                            <FormGroup
                                labelSize={"col-sm-3"}
                                inputSize={"col-sm-6"}
                                variant={FORM_GROUP_VARIANTS.TEXT}
                                label={CONTENT_STRINGS.NAME}
                                inputProps={{
                                    disabled: toba.tobaFormData.defaultToba,
                                    required: true,
                                    name: 'name',
                                    value: toba.tobaFormData.name,
                                    onChange: handleFieldChange,
                                }}
                                formGroupTestId={'toba-name'}
                            />
                        ) : null
                    }
                    <FormGroup
                        labelSize={"col-sm-3"}
                        inputSize={"col-sm-6"}
                        variant={FORM_GROUP_VARIANTS.TEXT}
                        label={CONTENT_STRINGS.VERSION_NAME}
                        inputProps={{
                            required: true,
                            name: 'version',
                            value: toba.tobaFormData.version,
                            onChange: handleFieldChange,
                        }}
                        formGroupTestId={'toba-version-name'}
                    />
                    {
                        showNameAndGroups ? (
                            <div>
                                <FormGroup
                                    labelSize={"col-sm-3"}
                                    inputSize={"col-sm-6"}
                                    variant={FORM_GROUP_VARIANTS.TEXT}
                                    label={solicitorGroupsLabel}
                                    inputProps={{
                                        placeholder: solicitorGroupsPlaceholder,
                                        name: 'solicitorGroupFilter',
                                        value: toba.tobaFormData.solicitorGroupFilter || '',
                                        onChange: handleFieldChange,
                                    }}
                                    formGroupTestId={'toba-solicitor-groups-search'}
                                />
                                <FormGroup
                                    labelSize={"col-sm-3"}
                                    inputSize={"col-sm-6"}
                                    variant={FORM_GROUP_VARIANTS.SELECT_MANY}
                                    inputProps={{
                                        options: selectManyOptions,
                                        value: selectManyValue,
                                        onChange: handleSelectManyChange,
                                    }}
                                    formGroupTestId={'toba-solicitor-groups'}
                                />
                            </div>
                        ) : null
                    }
                    <div className={"form-group"}>
                        <div className={"col-sm-3"}>
                            <FormGroup
                                labelSize={"col-sm-3"}
                                inputSize={"col-sm-6"}
                                variant={FORM_GROUP_VARIANTS.PLAIN}
                                label={CONTENT_STRINGS.CONTENT_LABEL}
                                inputProps={{
                                    id: 'tobaBody',
                                    name: 'tobaBody',
                                    required: true,
                                }}
                                formGroupTestId={'toba-content'}
                            />
                        </div>
                        <div className={"col-sm-6 formGroupTextArea-wrapper"}>
                            <CustomEditor
                                value={toba.tobaFormData.tobaBody}
                                onEditorChange={handleTobaBodyChange}
                            />
                        </div>
                    </div>
                    <FormGroup
                        labelSize={"col-sm-3"}
                        inputSize={"col-sm-6"}
                        variant={FORM_GROUP_VARIANTS.DATE}
                        label={CONTENT_STRINGS.VALID_FROM}
                        inputProps={{
                            required: true,
                            label: toba.tobaFormData.validFrom,
                            dateInputProps: {
                                name: 'validFrom',
                                onChange: handleValidFromChange,
                                minDate: minDate,
                                dateFormat: DATE_FORMAT,
                                selected: validFromDate,
                                placeholderText: CONTENT_STRINGS.DATE_PLACEHOLDER,
                                value: validFromDate,
                                required: true,
                                autoComplete: 'off',
                            },
                        }}
                        formGroupTestId={'toba-valid-from'}
                    />
                    <div className={"row"}>
                        <div className={"col-sm-6 col-sm-offset-3"}>
                            <DragAndDrop
                                label={CONTENT_STRINGS.UPLOAD_FILE_TOOLTIP}
                                accepts={DROPZONE_ACCEPTED_FILES_ARRAY}
                                allowMultiple={true}
                                onDrop={_onDrop}
                                ddTestId={'toba-file-upload'}
                            />
                        </div>
                    </div>
                    {
                        hasSelectedGroups ? (
                            <div className={'form-group'}>
                                <div className={'col-sm-6 col-sm-offset-3'}>
                                    <Heading
                                        variant={HEADING_4}
                                        title={selectedGroupsTitle}
                                    />
                                    <List
                                        listTestId={'create-toba-modal-selected-solicitor-groups'}
                                        items={selectedGroupListItems}
                                    />
                                </div>
                            </div>
                        ) : null
                    }
                    {
                        hasExistingToba 
                        ?
                            <div className={"form-group"} style={{ display: 'flex', flexDirection: 'column', gap: '10px'}}>
                                <div className={"col-sm-6 col-sm-offset-3"}>
                                    <GroupButtons
                                        primaryLabel={CONTENT_STRINGS.SAVE_AND_CREATE_NEW_REVISION}
                                        primaryVariant={PRIMARY}
                                        primaryType={SUBMIT}
                                        primaryTestId={'toba-save-as-new-revision'}
                                        secondaryLabel={CONTENT_STRINGS.SAVE_CURRENT_REVISION}
                                        onSecondaryClick={_handleUpdate}
                                        secondaryVariant={TERTIARY}
                                        secondaryType={BUTTON}
                                        secondaryTestId={'toba-save-revision'}
                                    />
                                </div>
                                <div className={"col-sm-6 col-sm-offset-3"}>
                                    <Button
                                        onClick={goBack}
                                        label={CONTENT_STRINGS.CANCEL}
                                        variant={QUATERNARY}
                                        arrowDirection={RIGHT}
                                        buttonTestId={'toba-cancel'}
                                    />
                                </div>
                            </div>
                        :
                            <div className={"form-group"}>
                                <div className={"btn-wrapper-forForms col-sm-6 col-sm-offset-3"} style={{ display: 'flex', gap: '10px'}}>
                                    <Button
                                        type={SUBMIT}
                                        label={saveButtonLabel}
                                        variant={PRIMARY}
                                        arrowDirection={RIGHT}
                                        buttonTestId={'create-toba-modal-create'}
                                    />
                                    <Button
                                        onClick={cancelHandler}
                                        label={CONTENT_STRINGS.CANCEL}
                                        variant={QUATERNARY}
                                        arrowDirection={RIGHT}
                                        buttonTestId={'create-toba-modal-cancel'}
                                    />
                                </div>
                            </div>
                    }
                    {
                        toba.badResponse !== '' ? (
                            <div className={"form-group"}>
                                <div className={"col-sm-6 col-sm-offset-3"}>
                                    <Alert variant={ERROR} label={toba.badResponse} />
                                </div>
                            </div>
                        ) : null
                    }
                    {
                        toba.successMsg !== '' ? (
                            <div className={"form-group"}>
                                <div className={"col-sm-6 col-sm-offset-3"}>
                                    <Alert variant={SUCCESS} label={toba.successMsg} />
                                </div>
                            </div>
                        ) : null
                    }
                    {
                        toba.failMsg !== '' ? (
                            <div className={"form-group"}>
                                <div className={"col-sm-6 col-sm-offset-3"}>
                                    <Alert variant={ERROR} label={toba.failMsg} />
                                </div>
                            </div>
                        ) : null
                    }
                    {
                        toba.posting ? (
                            <div className={"form-group"}>
                                <div className={"col-sm-3"}>
                                </div>
                                <div className={"col-sm-9"}>
                                    <div className={"col-sm-4"}></div>
                                    <Loader variant={DOTS} dotSize={MEDIUM} />
                                </div>
                            </div>
                        ) : null
                    }
                    {
                        toba.updateTobaSuccessMessage !== '' ? (
                            <div className={"form-group"}>
                                <div className={"col-sm-6 col-sm-offset-3"}>
                                    <Alert variant={SUCCESS} label={toba.updateTobaSuccessMessage} />
                                </div>
                            </div>
                        ) : null
                    }
                    {
                        toba.updateTobaFailMessage !== '' ? (
                            <div className={"form-group"}>
                                <div className={"col-sm-6 col-sm-offset-3"}>
                                    <Alert variant={ERROR} label={toba.updateTobaFailMessage} />
                                </div>
                            </div>
                        ) : null
                    }
                    {
                        toba.updatingToba ? (
                            <Loader variant={DOTS} dotSize={MEDIUM} />
                        ) : null
                    }
                </form>
                <div className={"row"}>
                    <div className={"col-sm-6 col-sm-offset-3"}>
                        <AttachmentsList
                            attachments={attachments}
                            onAttachmentRemove={onAttachmentRemove}
                            listTestId={'create-toba-modal-files'}
                            listItemTestId={'create-toba-modal-file'}
                        />
                    </div>
                </div>
                {
                    hasFetchedAttachments ? (
                        <div className={"row"}>
                            <div className={"col-sm-6 col-sm-offset-3"}>
                                <HorizontalRule variant={DOTTED} />
                                <Heading
                                    variant={HEADING_4}
                                    title={CONTENT_STRINGS.FILES_ALREADY_ATTACHED}
                                />
                                <AttachmentsList
                                    attachments={fetchedAttachments}
                                    onAttachmentRemove={onFetchedAttachmentRemove}
                                    onAttachmentRequest={handleDownloadFile}
                                    listTestId={'toba-attached-files'}
                                    listItemTestId={'toba-attached-files'}
                                />
                            </div>
                        </div>
                    ) : null
                }
                {
                    toba?.previousTobas?.length > 0 
                    ?
                        <div>
                            <div className={"row"}>
                                <div className={"col-sm-12"}>
                                    <HorizontalRule variant={DOTTED} />
                                </div>
                            </div>
                            <Heading
                                variant={HEADING_3}
                                title={revisionsTitle}
                            />
                            {
                                toba.fetchingTobaRevisions ? (
                                    <Loader variant={DOTS} dotSize={MEDIUM} />
                                ) : null
                            }
                            <List
                                listTestId={'toba-revisions'}
                                id={'toba-previous-revision-list'}
                                items={previousRevisionListItems}
                            />
                            <ModalWrapper
                                isOpen={toba.openModal}
                                onClose={closeTobaRevisionModal}
                                title={revisionModalTitle}
                                size={SIZE_LG}
                                modalTestId={'toba-modal'}
                            >
                                <TobaRevision
                                    defaultToba={toba.tobaFormData.defaultToba}
                                    tobaRevision={toba.selectedPreviousToba}
                                    fetchingTobaRevision={toba.fetchingTobaRevision}
                                    populateTobaFormFromRevision={populateTobaFormFromRevision}
                                    _getFileFromBase64={_getFileFromBase64}
                                />
                            </ModalWrapper>
                        </div>
                    : 
                        null
                }
            </div>
        </div>
    );
};

export default NewTobaForm;